import { FC, useContext } from "react";
import { AuthContext } from "@/guards/auth/auth-context";
import { GenericError } from "@/assets/illustrations";
import { EmptyDataScreen } from "@/components";
import { map } from "lodash";
import { MisConfiguredPageProps } from "./types";
import styles from "./styles.scss";
import { getLogLevel } from "@/utils/get-log-level";
import { LoggingLevel } from "@/utils/logger/constants";
import { checkIsDevEnvironment } from "@/utils";

export const MisConfiguredPage: FC<MisConfiguredPageProps> = ({ errors }) => {
  const { error: authError } = useContext(AuthContext);

  if (authError || errors) {
    return (
      <EmptyDataScreen
        title="Application is misconfigured"
        subtitle={
          errors &&
          (checkIsDevEnvironment() ||
            Number(getLogLevel()) === LoggingLevel.Critical ||
            Number(getLogLevel()) === LoggingLevel.All) ? (
            <ul className={styles.errorsList}>
              {map(errors, ({ path, message }, index) => {
                return (
                  <li key={`error-${index}`}>
                    {path ? path.join(" - ") : ""} : {message}
                  </li>
                );
              })}
            </ul>
          ) : (
            <>
              <div>Configuration object has invalid parameters,</div>
              <div>please contact your administrator</div>
            </>
          )
        }
        icon={<GenericError />}
      />
    );
  }

  return null;
};
